export default __webpack_public_path__ + "static/media/Promo.04af4230.svg";